module.exports = __webpack_public_path__ + "img/Weapon_68.dcd13e1e.png";